"use strict";

app.GlobalOverlay = {
    mounted: function mounted() {},
    update: function update() {},
    getData: function getData() {
        return {};
    },
    dispose: function dispose() {}
};